export const defaultStyle = `
  height: 100%;
  overflow: auto;

  .cm-theme,
  .cm-editor {
    height: 100%;
    line-height: 1.45em;
  }
`;
